import type {IAccessClaim} from '@igp/shared/access-control';
import {BaseAccessRule} from '@igp/shared/access-control';

import type {DebtResponsibleMasterAgentViewModel} from '@features/debt-responsible-master-agent';

const debtResponsibleMasterAgentAccessClaimType = 'debtResponsibleMasterAgentAccessClaim';

export class DebtResponsibleMasterAgentAccessClaim implements IAccessClaim {
    constructor(readonly model?: DebtResponsibleMasterAgentViewModel) {}
    get type(): string {
        return debtResponsibleMasterAgentAccessClaimType;
    }
}

export class DebtResponsibleMasterAgentAccessRule extends BaseAccessRule<DebtResponsibleMasterAgentAccessClaim> {
    constructor() {
        super(
            [new DebtResponsibleMasterAgentAccessClaim({} as DebtResponsibleMasterAgentViewModel)],
            debtResponsibleMasterAgentAccessClaimType
        );
    }

    validate(userClaims: DebtResponsibleMasterAgentAccessClaim[]): boolean {
        const filteredUserClaims = this.filterClaims(userClaims);
        return filteredUserClaims?.some(claim => claim.model);
    }

    toString(): string {
        return 'User is Debt Responsible Master Agent';
    }
}

export class RestrictedDebtResponsibleMasterAgentAccessRule extends BaseAccessRule<DebtResponsibleMasterAgentAccessClaim> {
    constructor() {
        super([], debtResponsibleMasterAgentAccessClaimType);
    }

    validate(userClaims: DebtResponsibleMasterAgentAccessClaim[]): boolean {
        const filteredUserClaims = this.filterClaims(userClaims);
        return !filteredUserClaims?.some(claim => claim.model);
    }

    toString(): string {
        return 'User is not Debt Responsible Master Agent';
    }
}
